import { Alerta, Button, Row, Stack, TextField } from "@/components";
import { useFormularioInicio } from "./useFormularioInicio";

export interface FormularioInicioProps {
  fid: number;
  inicial: string | null;
  onGuardado: () => void;
  onCancelar: () => void;
}

/** Fecha de inicio de obra: opcional, día hábil. Vacía = "a definir". */
export function FormularioInicio({ fid, inicial, onGuardado, onCancelar }: FormularioInicioProps) {
  const f = useFormularioInicio(fid, inicial, onGuardado);
  return (
    <form onSubmit={(e) => void f.guardar(e)} noValidate>
      <Stack espacio={4}>
        <TextField
          etiqueta="Fecha de inicio de obra"
          type="date"
          value={f.valor}
          onChange={(e) => f.cambiar(e.target.value)}
          error={f.error}
          ayuda="De lunes a viernes. Dejala vacía si todavía no se sabe."
        />
        <Alerta texto={f.errorGuardar} />
        <Row justificar="fin" espacio={2}>
          <Button type="button" variante="secundario" onClick={onCancelar}>
            Cancelar
          </Button>
          <Button type="submit" cargando={f.guardando}>
            Guardar
          </Button>
        </Row>
      </Stack>
    </form>
  );
}
